import { ProfilePage } from '@hds/identity-and-authentication-ui-lib/desktop';

import { createShellRoutes } from '../shared/routes.js';

// The app shell, for a desktop app: the App Menu, the Avatar Menu that opens it,
// and the Settings page. The UI is the same one a phone app gets. What a choice
// DOES is not: a desktop saves a preference in the browser's own storage, which
// is what the shell does unless a target says otherwise — so nothing is
// installed here.
export { default as AppMenu } from '../shared/AppMenu.vue';
export { default as AvatarMenu } from '../shared/AvatarMenu.vue';
export { default as SettingsPage } from '../shared/SettingsPage.vue';
export { SHELL_PATHS, useAppMenuStore } from '../shared/appMenuStore.js';
export { useSettingsStore } from '../shared/settingsStore.js';
export { useThemeStore } from '../shared/themeStore.js';
export { useLanguageStore } from '../shared/languageStore.js';

// The one routes line an app adds for the shell.
export const commonUiRoutes = createShellRoutes({ ProfilePage });
